/* eslint-disable unicorn/prefer-global-this */
import $ from 'jquery'
import ath from 'add-to-homescreen'
// Must be imported first in index.ts. Plugins like bootstrap-paginator read window.jQuery
// as a call argument at module eval time — @rollup/plugin-inject can't rewrite that.
// A dedicated module ensures this runs before vendor deps are evaluated.

window.$ = $
window.jQuery = $
window.addToHomescreen = ath
